import React from 'react';
import { User, Bot } from 'lucide-react';
import { ActivityFeed } from './ChatProgress';
import '../../styles/ChatMenu.css';

const ChatMessage = ({ message }) => {
  const isUser = message.role === 'user' || message.type === 'user';

  const formatContent = (content) => {
    // Convert markdown-style formatting
    let formatted = content;

    // Bold text
    formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

    // Italic text
    formatted = formatted.replace(/\*(.*?)\*/g, '<em>$1</em>');

    // Code blocks
    formatted = formatted.replace(
      /```(.*?)```/gs,
      '<pre><code>$1</code></pre>'
    );

    // Inline code
    formatted = formatted.replace(/`(.*?)`/g, '<code>$1</code>');

    // Line breaks
    formatted = formatted.replace(/\n/g, '<br />');

    return { __html: formatted };
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className={`chat-message ${isUser ? 'user' : 'assistant'}`}>
      <div className="chat-message-avatar">
        {isUser ? <User size={16} /> : <Bot size={16} />}
      </div>
      <div className="chat-message-content">
        {message.activity ? (
          <ActivityFeed activity={message.activity} />
        ) : (
          <div
            className="chat-message-text"
            dangerouslySetInnerHTML={formatContent(message.content)}
          />
        )}
        <div className="chat-message-time">{formatTime(message.timestamp)}</div>
      </div>
    </div>
  );
};

export default ChatMessage;
